<template>
	<dl class="optionInfo sort-item" v-if="!(ptInitData.siteKbn == '4' && !ptInitData.loginKbn)">
		<div class="optionGroup" v-for="(item, index) in pt125ReqModel.optionGroupList" :key="index">
			<div v-if="item.REQUIRED_FLG == '1'">{{ $t(item.OPTION_NAME) }}&nbsp;&nbsp;<span
					class="font-weight-bold text-danger">{{ $t("必須") }}</span></div>
			<div v-else>{{ $t(item.OPTION_NAME) }}&nbsp;&nbsp;<span class="font-weight-bold">{{ $t("任意") }}</span></div>
			<div v-if="item.OPTION_KBN == '1'">
				<select class="col p-0  form-control w-100" v-model="item.OPTION_VALUE2">
					<template v-for="itemOption in pt125ReqModel.optionList">
						<option v-if="item.OPTION_NO == itemOption.OPTION_NO" :key="itemOption.OPTION_VALUE"
							:value="itemOption.OPTION_VALUE">
							{{ itemOption.OPTION_NAME }}
						</option>
					</template>
				</select>
			</div>
			<div v-if="item.OPTION_KBN == '3'">
				<template v-for="itemOption in pt125ReqModel.optionList">
					<div v-if="item.OPTION_NO == itemOption.OPTION_NO" :key="itemOption.OPTION_VALUE"
						:value="itemOption.OPTION_VALUE">
						<textarea v-model="itemOption.OPTION_NAME" id="optionNameContents" rows="4" maxlength="85">
                                                </textarea>
					</div>
				</template>
			</div>
		</div>
	</dl>
</template>
<script>
export default {
	props: {
		ptInitData: {
			type: Object,
			default: {}
		},
		pt125ReqModel: {
			type: Object,
			default: null
		}
	},
	methods: {
	}
}
</script>